import { Link } from 'react-router-dom';
import { CompassIcon } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-surface-700/60 text-ivory-500">
        <CompassIcon className="h-6 w-6" strokeWidth={1.5} />
      </span>
      <h1 className="font-display text-lg font-semibold text-ivory-100">Seite nicht gefunden</h1>
      <Link to="/" className="text-sm font-medium text-accent-400 hover:underline">
        Zurück zum Dashboard
      </Link>
    </div>
  );
}
